var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, createContext } from 'react';
import { Drawer } from '@one-thd/sui-atomic-components';
var DrawerContext = createContext(null);
var DrawerProvider = function (_a) {
    var children = _a.children;
    var initialState = {
        ContentComponent: null,
        componentProps: {},
        drawerProps: {},
        isOpened: false,
    };
    var _b = useState(initialState), drawerState = _b[0], setDrawerState = _b[1];
    /**
     * openDrawer function.
     *
     * @param {React.FC} ContentComponent - a drawer content component
     * @param {any} [componentProps={}] - a drawer content component (ContentComponent) props
     * @param {IDrawerProps} [drawerProps={}] - a stencil drawer props
     *
     * @example
     *     const BasicDrawerContent = ({title}: string) => <p>This is a basic drawer's content. {title}</p>;
     *     // Update  stencil drawer props
     *     const drawerProps = { position: 'left' };
     *
     *     openDrawer(BasicDrawerContent, { title: 'Drawer Title' }, drawerProps);
     */
    var openDrawer = function (ContentComponent, componentProps, drawerProps) {
        if (drawerProps === void 0) { drawerProps = {}; }
        setDrawerState({
            ContentComponent: ContentComponent,
            componentProps: componentProps,
            drawerProps: drawerProps,
            isOpened: true,
        });
    };
    /**
     * hideDrawer function for hiding (closing) opened drawer
     *
     */
    var hideDrawer = function () {
        setDrawerState(function (_a) {
            var drawerProps = _a.drawerProps;
            return ({
                ContentComponent: null,
                componentProps: {},
                drawerProps: {
                    position: drawerProps.position,
                },
                isOpened: false,
            });
        });
    };
    var setComponentProps = function (componentProps) {
        setDrawerState(function (prevDrawerState) { return (__assign(__assign({}, prevDrawerState), { componentProps: __assign(__assign({}, prevDrawerState.componentProps), componentProps) })); });
    };
    return (React.createElement(DrawerContext.Provider, { value: {
            openDrawer: openDrawer,
            hideDrawer: hideDrawer,
            isOpened: drawerState.isOpened,
            setComponentProps: setComponentProps,
        } },
        React.createElement(Drawer, __assign({ open: drawerState.isOpened, onClose: hideDrawer }, drawerState.drawerProps), drawerState.ContentComponent && (React.createElement(drawerState.ContentComponent, __assign({ hideDrawer: hideDrawer }, drawerState.componentProps)))),
        children));
};
export { DrawerProvider, DrawerContext };
